export default __webpack_public_path__ + "static/media/woocommerce.06e81243.svg";